import React from "react";
import { Control, RegisterOptions } from "react-hook-form";

import { MultiSelect, InputFieldProps } from "shared/components";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { IPeoplePickerSettings } from "shared/types";

import { useLogic } from "./useLogic";
import { copy } from "shared/assets";

interface PeoplePickerProps extends Omit<InputFieldProps, "value"> {
  value?: ISelectOption[] | null;
  control: Control;
  validation?: RegisterOptions;
  setFieldValue?: (field: string, value: string[] | null) => void;
  defaultValue?: string[] | undefined;
  settings?: IPeoplePickerSettings;
}

export const PeoplePicker: React.FC<PeoplePickerProps> = ({
  value,
  defaultValue,
  placeholder,
  onChange,
  settings,
  ...rest
}) => {
  const [options, categories, hasInvitedUsers] = useLogic(settings || {});

  return (
    <MultiSelect
      {...rest}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder || "@"}
      options={options}
      categories={categories}
      onChange={onChange}
      note={
        <span>
          {rest.note}{" "}
          {!settings?.includeInvitedUsers &&
            hasInvitedUsers &&
            copy.event.email.fields.membersToMailHelpExtra}
        </span>
      }
    />
  );
};
